module.exports = __webpack_public_path__ + "img/antes_despues_125.fbc9a4df.png";